export default {
    name: 'requests',
    serverName: '/v1/requests',
    apiUrl: '/v1/requests/',
    apiTaskUrl: '/v1/task/',
    apiFileUrl: '/v1/task-file/'
};
